require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-75-collborator-or-label.json") })
        }
      }, "path---article-75-collborator-or-label");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-75-collborator-or-label!./.cache/json/article-75-collborator-or-label.json
// module id = 565
// module chunks = 231608221292675